import React from 'react'
import {Time} from 'yougile-util'
import {CrmActivitiesFilters, CrmActivitiesView} from '../common'
import {getDayFull} from '../custom-format-date'
import {BorderedIconButton} from './bordered-icon-button'

interface DayFilterComponentProps {
  filters: CrmActivitiesFilters
  setFilters: (filters: CrmActivitiesFilters) => void
  activitiesView: CrmActivitiesView
}

export const DayFilterComponent = (props: DayFilterComponentProps) => {
  const {filters, setFilters, activitiesView} = props

  return (
    <div className="flex items-center max-h-20 gap-4">
      <div
        className="flex items-center gap-12 cursor-pointer"
        onClick={() =>
          setFilters({
            ...filters,
            selectedDay: filters.selectedDay - Time.day
          })
        }
      >
        <div className="w-full text-center text-xs-regular text-placeholder min-w-80">{`${getDayFull(
          filters.selectedDay - Time.day
        )} (${activitiesView.stats?.dayPrev ?? 0})`}</div>

        <BorderedIconButton
          icon={'IconCustomChevronLeft'}
          onClick={() =>
            setFilters({
              ...filters,
              selectedDay: filters.selectedDay - Time.day
            })
          }
        />
      </div>

      <div className="w-full text-center text-xs-regular text-primary min-w-80 cursor-default">{`${getDayFull(
        filters.selectedDay
      )} (${activitiesView.stats?.dayCurrent ?? 0})`}</div>

      <div
        className="flex items-center gap-12 cursor-pointer"
        onClick={() =>
          setFilters({
            ...filters,
            selectedDay: filters.selectedDay + Time.day
          })
        }
      >
        <BorderedIconButton
          icon={'IconCustomChevronRight'}
          onClick={() =>
            setFilters({
              ...filters,
              selectedDay: filters.selectedDay + Time.day
            })
          }
        />

        <div className="w-full text-center text-xs-regular text-placeholder min-w-80">{`${getDayFull(
          filters.selectedDay + Time.day
        )} (${activitiesView.stats?.dayNext ?? 0})`}</div>
      </div>
    </div>
  )
}
